import React, { Component } from 'react';


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

class BranchList extends Component {

    constructor(props) {
        super(props);
    }

    defaultColDef = {
        editable: false,
        sortable: true,
        resizable: true,
        headerClass:'bg-dark text-light',
        suppressMovable: true
    };
    listColumn = [
        {
            headerName: "ID",
            field: "ID",
            sortable: true,
            minWidth: 50,
            cellClass: "text-center"
        },
        {
            headerName: "지사 이름",
            field: "NAME",
            sortable: true,
            minWidth: 130,
            cellClass: "text-center"
        },
        {
            headerName: "관할",
            field: "TOTAL_BIZ_BRANCH",
            sortable: true,
            minWidth: 50,
            cellClass: "text-center text-success"
        },
        {
            headerName: "관외",
            field: "TOTAL_NOT_BIZ_BRANCH",
            sortable: true,
            minWidth: 50,
            cellClass: "text-center text-danger"
        },
        {
            headerName: "유치원",
            field: "CONTRACT_NURSERY_COUNT",
            sortable: true,
            minWidth: 70,
            cellClass: "text-center text-info"
        },
        {
            headerName: "어린이집",
            field: "CONTRACT_DAYCARE_COUNT",
            sortable: true,
            minWidth: 70,
            cellClass: "text-center text-brand"
        },
        {
            headerName: "미분류",
            field: "CONTRACT_NULL_COUNT",
            sortable: true,
            minWidth: 70,
            cellClass: "text-center text-secondary"
        },
    ];

    onBranchSelect() {
        var selectedRows = this.gridApi.getSelectedRows();
        if (selectedRows != null && selectedRows.length > 0) {
            this.props.onBranchSelectHandler(selectedRows[0]);
        }
    }

    onGridReady = params => {
        this.gridApi = params.api;
    }

    onFirstDataRendered = params => {
        params.api.sizeColumnsToFit();
    }

    render() {
        if (this.props.branchList == null) {
            return (
                <div className="card">
                    <div className="card-body" style={{ height: this.props.height + "px", textAlign: "center", paddingTop: "50px" }}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </div>
            )
        } else if (this.props.branchList.length === 0) {
            return (
                <div className="card">
                    <div className="card-body" style={{ height: this.props.height + "px" }}>
                        No Data
	                </div>
                </div>
            )
        } else {
            return (
                <div className="card">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-balham" style={{ width: "100%", height: (this.props.height - 62) + "px" }}>
                            <AgGridReact
                                columnDefs={this.listColumn}
                                defaultColDef={this.defaultColDef}
                                rowData={this.props.branchList}
                                rowHeight={40}
                                rowSelection="single"
                                onGridReady={this.onGridReady}
                                onSelectionChanged={this.onBranchSelect.bind(this)}
                                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                            >
                            </AgGridReact>
                        </div>
                    </div>
                </div>
            )
        }

    }

}


export default BranchList;